import React from 'react'

export const SubSectionHeaderTypography = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  (props, ref) => {
    const { className, ...rest } = props
    return <p ref={ref}
              className={`text-xs uppercase ${className ?? ''}`} {...rest}>{props.children}</p>
  }
)